import { TAnswerState } from '../../../../containers/FormContainer/types/internal';

export const rangeMapper = (answerState: TAnswerState) => {
  return { [answerState.answerField]: answerState.value };
};
